export default "__VITE_ASSET__BprTkFw6__"